import { useApolloClient } from '@graphcommerce/graphql'
import { useAssignCurrentCartId } from '@graphcommerce/magento-cart'
import { CreateEmptyCartDocument } from '@graphcommerce/magento-cart/hooks/CreateEmptyCart.gql'
import { useCartLock } from '@graphcommerce/magento-cart-payment-method'
import { i18n } from '@lingui/core'
import { useCallback, useEffect } from 'react'

// If a user previously had an order, went through the checkout and into the PSP environment, but did not cancel his order (but instead just closed the window) it is possible their cart is still locked
// In this case, we should discard their current cart and create a new one. (In the future we may decide for these carts to be unlocked again, something to consider)
// Carts can easily be unlocked:
// || import { useApolloClient } from '@graphcommerce/graphql'
// || const { cache } = useApolloClient()
// || cartLock(cache, false)
// but in order to do this we must first make sure the cart should be unlocked (a successful order also results in a lost cart) so thats why we choose to discard a locked cart at the moment, rather than restore it

export function usePreventLockedCart() {
  const [lockState] = useCartLock()
  const client = useApolloClient()
  const assignCurrentCartId = useAssignCurrentCartId()
  const replaceLockedCart = useCallback(async () => {
    try {
      const { data: newCart } = await client.mutate({ mutation: CreateEmptyCartDocument })
      if (!newCart?.createEmptyCart)
        throw Error(i18n._(/* i18n */ 'Could not create an empty cart'))

      assignCurrentCartId(newCart.createEmptyCart)
    } catch (error) {
      console.error('Error replacing locked cart:', error)
    }
  }, [assignCurrentCartId, client])

  useEffect(() => {
    if (lockState.locked) {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      replaceLockedCart()
    }
  }, [lockState.locked, replaceLockedCart])
}
